import { BuildingConfiguration } from '@components-domain/generation';

/**
 * Constant: emptyBuildingConfiguration
 * 
 * This constant represents an empty building configuration with default values.
 */
export const emptyBuildingConfiguration: BuildingConfiguration = {
  info: {
    id: '',
    name: '',
    description: '',
    location: {
      coordinates: {
        latitude: 0.0,
        longitude: 0.0,
        altitude: 0.0,
      },
    },
    rotation: {
      type: 'ProjectNorth',
      angle: {
        creationType: 'RANDOM',
        generatorType: 'INTEGER',
        value: 0,
        options: {
          min: 0,
          max: 360,
        },
      },
    },
    height: {
      type: 'FLOOR',
      value: {
        creationType: 'CONSTANT',
        generatorType: 'INTEGER',
        value: 0,
      },
    },
    numberOfLevels: 0,
    moduleSize: 1,
    modular: false,
  },
  layout: {
    rowFirst: {
      numberOfRooms: 0,
      rooms: [],
      width: 0,
    },
    corridor: {
      width: 1,
    },
    rowSecond: {
      numberOfRooms: 0,
      rooms: [],
      width: 0,
    },
  },
  elementTypes: {
    wallInterior: {
      creationType: 'CONSTANT',
      generatorType: 'NUMBER',
      options: {
        elements: '',
      },
    },
    wallExterior: {
      creationType: 'CONSTANT',
      generatorType: 'NUMBER',
      options: {
        elements: '',
      },
    },
    floor: {
      creationType: 'CONSTANT',
      generatorType: 'NUMBER',
      options: {
        elements: '',
      },
    },
    floorGround: {
      creationType: 'CONSTANT',
      generatorType: 'NUMBER',
      options: {
        elements: '',
      },
    },
    windowType: {
      creationType: 'CONSTANT',
      generatorType: 'NUMBER',
      options: {
        elements: '',
      },
    },
    roof: {
      creationType: 'CONSTANT',
      generatorType: 'NUMBER',
      options: {
        elements: '',
      },
    },
  },
  configInformation: {
    courseId: '',
    assignmentId: '',
    name: '',
    description: '',
  },
} as any;